export const serviceBlog = {
  en: {
    services: "Services",
    coaching: "Coaching",
    webDesign: "Web Design",
    aiServices: "AI Services",
    booking: "Booking",
    orderOnline: "Order Online",
  },
  vi: {
    services: "Dịch vụ",
    coaching: "Tư vấn nghề nghiệp",
    webDesign: "Thiết kế website",
    aiServices: "Dịch vụ AI",
    booking: "Đặt lịch hẹn online",
    orderOnline: "Đặt món online", // ✅ best choice
  },
};
